import { useEffect, useState } from "react";
import ImageSection from "./ImageSection"
import env from "../../constants/env";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "../Assets/style";
import SecondaryNav from '../../components/Nav/SecondaryNav';
import { Container, LoaderWrapper, SuccessContainer } from "./style";
import { DataSection } from "./DataSection";
import Button from "../../components/Button";
import { BodySemibold, Subtitle, SubtitleMedium } from "../../shared/typography";
import { ReactComponent as SuccessIcon } from '../../assets/success_icon.svg'
import { LoadingAnimation } from "../../components/ProcessingModal/Animation";
import { openWalletVerify } from "../../redux/walletReducer";
import wallet_yellow_outline from "../../assets/icons/wallet_yellow_outline.svg";
import proxy_token_abi from "../../constants/abi";
import Web3 from "web3";

interface IAssetInfo {
    assetChain: string;
    assetWalletAddress: string;
    assetContractAddress: string;
    assetId: string;
    proxy_token_id: string;
    proxy_token_exists: boolean;
}

export const BurnProxyToken = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let wallet = useSelector((state: RootState) => state.walletState);

    const [searchParams, setSearchParams] = useSearchParams();
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [nftData, setNftData] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);

    const [isBurnt, setIsBurnt] = useState(false);
    const [assetInfo, setAssetInfo] = useState<Partial<IAssetInfo>>({});
    const [nftMetadata, setNftmetadata] = useState<any>({});


    const fetchNftInfo = async () => {
        try {
            setIsLoading(true)
            const options = {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "X-API-Key": env.MORALIS_API_KEY,
                },
            };
            //   'https://deep-index.moralis.io/api/v2/nft/0x7dE3085b3190B3a787822Ee16F23be010f5F8686/15/metadata?chain=eth' - moralis api structure
            console.log('assetInfo', assetInfo);
            const validity: any = await axios.get(
                `${env.PUBLIC_URL}/checkProxyTokenValidity/${assetInfo?.assetId}`
            );

            setIsBurnt(!Boolean(validity?.data?.isProxyTokenValid))
            const nftData_ = await axios.get(
                `${env.MORALIS_URL}/api/v2/nft/${assetInfo.assetContractAddress}/${assetInfo.assetId
                }?chain=${assetInfo.assetChain == "ETH" ? env.ETH_CHAIN : env.POLYGON_CHAIN
                }`,
                options
            );
            if (!nftData_?.data?.metadata) {
                const web3 = new Web3(env.POLYGON_RPC_URL);
                const proxyContract = new web3.eth.Contract(
                    proxy_token_abi,
                    env.PROXY_TOKEN_CONTRACT_ADDRESS
                );
                const itemDataURL = await proxyContract.methods.tokenURI(nftData_?.data?.token_id).call();
                const itemMetaData = await axios.get(itemDataURL)
                nftData_.data.metadata = JSON.stringify(itemMetaData?.data)
            }
            setNftmetadata(nftData_.data);
            setNftData(JSON.parse(nftData_?.data?.metadata));

        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    };

    const handleSignMessage = async () => {
        setIsLoading(true)
        try {

            const proxyTokenResp = await axios.get(
                `${env.USER_URL}/proxy-token-mint/${nftMetadata?.token_id}`
            )
            const proxyTokenData = proxyTokenResp?.data
            const accounts = await window.ethereum.request({ method: 'eth_accounts' })

            if (accounts[0]?.toLowerCase() !== proxyTokenData?.asset_storage_wallet_address?.toLowerCase()) {
                alert("You don't own this NFT, please switch your account")
                return
            }
            const resp = await axios.get(
                `${env.USER_URL}/proxy-token-mint/get-proxy-burn-message/${nftMetadata?.token_id}`
            )
            const signatureMsg = resp.data
            const signature = await window.ethereum.request({
                method: "personal_sign",
                params: [signatureMsg, accounts[0]],
            });

            await axios.post(
                `${env.USER_URL}/proxy-token-mint/burn-proxy-token`,
                {
                    proxy_token_id: nftMetadata?.token_id,
                    burn_request_signature: signature,
                    signer_wallet_address: accounts[0]
                },
                {
                    headers: {
                        Authorization: `Bearer ${wallet.jwtToken}`,
                    }
                }
            )
            await fetchNftInfo()

        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }


    useEffect(() => {
        const route = window.location.pathname.split("/");
        if (
            wallet.address == "" ||
            route.length != 7
        ) {
            return;
        }

        // if (route.length != 7) {
        //     navigate(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
        //     return;
        // }
        const obj = {
            assetChain: route[2],
            assetWalletAddress: route[3],
            assetContractAddress: route[4],
            assetId: route[5],
            proxy_token_id: route[6],
            proxy_token_exists:
                searchParams.get("proxy_token_exists") == "true" ? true : false
        }
        setAssetInfo(obj)
    }, [wallet]);

    useEffect(() => {
        if (assetInfo?.proxy_token_id) fetchNftInfo()
    }, [assetInfo])

    return (
        <Container>
            <SecondaryNav />
            <div className="section">
                {!wallet.address
                    ? <Col justify="space-between" align="center" gap="30px" width="100%">
                        <Col>
                            <SubtitleMedium>Wallet Not Connected</SubtitleMedium>
                            <BodySemibold>Please connect wallet to continue</BodySemibold>
                        </Col>
                        <Button
                            onClick={() => {
                                dispatch(openWalletVerify());
                            }}
                            width="168px"
                            type="BLACK"
                            iconSrc={wallet_yellow_outline}
                        >
                            Connect
                        </Button>
                    </Col>
                    : nftMetadata.metadata ? (
                        <Col>
                            <span className="titleSpan">
                                <h1 className="nameText">
                                    {nftData.name || `${nftMetadata?.name} #${nftMetadata?.token_id}`}
                                </h1>

                                {
                                    nftData.description
                                        ? (
                                            <div className="descriptionText">
                                                {showFullDescription
                                                    ? nftData.description
                                                    : (nftData?.description?.slice(0, 40) + (nftData?.description?.length > 40 ? '...' : ''))
                                                }
                                                <span
                                                    className="viewMoreText"
                                                    onClick={() => setShowFullDescription(!showFullDescription)}
                                                >
                                                    {showFullDescription ? " View Less" : " View More"}
                                                </span>
                                            </div>
                                        )
                                        : <span className="noDescriptionText">No Description</span>
                                }

                            </span>
                            <span className="main">
                                <ImageSection isVerify nftMetadata={nftMetadata} />
                                {
                                    isLoading
                                        ? <Row width="500px" align="center" justify="center">
                                            <LoaderWrapper>
                                                <LoadingAnimation />
                                            </LoaderWrapper>
                                        </Row>
                                        : <Col>
                                            {
                                                isBurnt
                                                    ? <SuccessContainer>
                                                        <SubtitleMedium>Success</SubtitleMedium>
                                                        <SuccessIcon />
                                                        <SubtitleMedium>The Proxy Token was Deleted</SubtitleMedium>
                                                        <Subtitle>You can close this tab</Subtitle>
                                                    </SuccessContainer>
                                                    : <>
                                                        <DataSection />
                                                        <Button type="BLACK" onClick={handleSignMessage}>
                                                            Burn the token
                                                        </Button>
                                                    </>
                                            }

                                        </Col>
                                }

                            </span>
                        </Col>

                    ) : (
                        ""
                    )}
            </div>


        </Container>

    )
}